import _ from 'lodash';
import { chartConfigPropTypes } from 'common/propTypes';
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { CHART_PATTERNS } from 'v2/common/constants/index';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';

const propTypes = {
  chartConfig: chartConfigPropTypes.isRequired,
  pipeType: PropTypes.string.isRequired,
  onUpdateChartConfig: PropTypes.func.isRequired
};
const defaultProps = {
  pipeType: '',
};

const PipeChartConfig = ({ pipeType, chartConfig, onUpdateChartConfig }) => {
  const { type } = chartConfig;
  const shouldHideChartTypes = pipeType === 'fixedRangeVolumeProfile';
  const disabledChartTypes = shouldHideChartTypes ? ['volumeCandle', 'openInterestCandle'] : [];

  const onChange = useCallback((chartType) => {
    onUpdateChartConfig({ chartConfig: { ...chartConfig, type: chartType } });
  }, [chartConfig, onUpdateChartConfig]);


  const toggleOptions = _.map(CHART_PATTERNS, ({ label, value, shouldShow }) => ({
    label,
    value,
    onClick: () => onChange(value),
    shouldShow,
    disabled: disabledChartTypes.includes(value)
  }));

  return (
    <div className="indicator-chart-type">
      <label className='col-form-label col-form-label-sm '>Chart Type</label>
      <ToggleGroupButton
        options={toggleOptions}
        defaultValue={type}
      />
    </div>
  );
};

PipeChartConfig.propTypes = propTypes;
PipeChartConfig.defaultProps = defaultProps;

export default memo(PipeChartConfig);
